export default ({ size, color = "rgba(0,0,0,1)", strokeWidth = 1 }) => {
  return (
    <svg
      viewBox="-2.4 -1 28.80 28.80"
      fill="none"
      stroke={color}
      stroke-width={strokeWidth}
      width={size}
      height={size}
    >
      <g stroke-width="0"></g>
      <g
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke={color}
        stroke-width="0.048"
      ></g>
      <g >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};
